import { Component } from '@theme/component';

/**
 * Dual-product featured section component.
 * Switches between two pre-rendered product panels when the user
 * clicks a product switcher pill button.
 *
 * @extends {Component}
 */
export class FeaturedProductsDuo extends Component {
  requiredRefs = ['panel'];

  /**
   * Switch the visible product panel and animate the pill.
   *
   * Called via on:change on the radio inputs:
   *   on:change="#{{ section.id }}/selectProduct?index=1"
   *
   * @param {{ index: number }} data
   */
  selectProduct({ index }) {
    const target = String(index);

    // Update pill animation data attributes
    const radios = this.querySelectorAll('input[type="radio"]');
    for (const radio of radios) {
      const isTarget = radio.value === target;
      radio.dataset.previousChecked = radio.checked && !isTarget ? 'true' : 'false';
      radio.dataset.currentChecked = isTarget ? 'true' : 'false';
    }

    // Update CTA href without hiding/showing the button
    const cta = this.refs['cta'];
    if (cta) cta.href = cta.dataset[`url${target}`];

    // Animate media panels only
    const panels = this.refs['panel'];
    const leavingPanel = panels.find((p) => !p.hidden);
    const enteringPanel = panels.find((p) => p.dataset.panel === target);

    if (!enteringPanel || leavingPanel === enteringPanel) return;

    if (leavingPanel) {
      leavingPanel.classList.add('is-leaving');
      leavingPanel.addEventListener(
        'animationend',
        () => {
          leavingPanel.classList.remove('is-leaving');
          leavingPanel.hidden = true;
          leavingPanel.setAttribute('aria-hidden', 'true');
        },
        { once: true }
      );
    }

    enteringPanel.hidden = false;
    enteringPanel.setAttribute('aria-hidden', 'false');
    void enteringPanel.offsetWidth; // force reflow so animation triggers
    enteringPanel.classList.add('is-entering');
    enteringPanel.addEventListener(
      'animationend',
      () => enteringPanel.classList.remove('is-entering'),
      { once: true }
    );
  }
}

if (!customElements.get('featured-products-duo')) {
  customElements.define('featured-products-duo', FeaturedProductsDuo);
}
